export const RELATIONSHIP_GROUP_ALIASES = {
  family: [
    'mom',
    'mother',
    'dad',
    'father',
    'son',
    'daughter',
    'brother',
    'sister',
    'grandmother',
    'grandfather',
    'grandma',
    'grandpa',
    'aunt',
    'uncle',
    'cousin',
    'niece',
    'nephew',
    'granddaughter',
    'grandson',
    'grandchild',
    'wife',
    'husband',
    'ex-wife',
    'ex-husband',
    'ex-girlfriend',
    'ex-boyfriend',
    'boyfriend',
    'girlfriend',
    'fiance',
    'fiancee',
    'partner',
    'child',
    'children',
    'parent',
    'parents',
  ],
  friends: ['friend', 'friends', 'best friend'],
  coworkers: [
    'coworker',
    'coworkers',
    'colleague',
    'colleagues',
    'boss',
    'manager',
    'employee',
    'employees',
  ],
  romantic: ['boyfriend', 'girlfriend', 'fiance', 'fiancee', 'wife', 'husband', 'partner', 'ex-wife', 'ex-husband', 'ex-girlfriend', 'ex-boyfriend'],
};

export function normalizeRelationshipRole(role = '') {
  return String(role).trim().toLowerCase();
}

export function detectGroupedRelationshipRecall(message = '') {
  const lower = message.toLowerCase();

  const recallPhrases = [
    'do you remember my',
    'who do you remember from my',
    'who do you remember in my',
    'who do you remember',
    'what friends do you remember',
    'what family do you remember',
    'what coworkers do you remember',
    'do you know my',
    'who do you know in my',
    'now who are my',
    'who are my',
    'remind me who my',
  ];

  const looksLikeRecall = recallPhrases.some((phrase) => lower.includes(phrase));
  if (!looksLikeRecall) return null;

  if (lower.includes('daughters')) return 'daughter';
  if (lower.includes('sons')) return 'son';
  if (lower.includes('brothers')) return 'brother';
  if (lower.includes('sisters')) return 'sister';
  if (lower.includes('mothers') || lower.includes('moms')) return 'mother';
  if (lower.includes('fathers') || lower.includes('dads')) return 'father';
  if (lower.includes('friends')) return 'friend';
  if (lower.includes('coworkers') || lower.includes('colleagues')) return 'coworker';
  if (lower.includes('aunts')) return 'aunt';
  if (lower.includes('uncles')) return 'uncle';
  if (lower.includes('cousins')) return 'cousin';
  if (lower.includes('nieces')) return 'niece';
  if (lower.includes('nephews')) return 'nephew';
  if (lower.includes('granddaughters')) return 'granddaughter';
  if (lower.includes('grandsons')) return 'grandson';
  if (lower.includes('grandchildren')) return 'grandchild';
  if (lower.includes('grandmothers') || lower.includes('grandmas')) return 'grandmother';
  if (lower.includes('grandfathers') || lower.includes('grandpas')) return 'grandfather';
  if (lower.includes('boyfriends')) return 'boyfriend';
  if (lower.includes('girlfriends')) return 'girlfriend';
  if (lower.includes('fiancés') || lower.includes('fiances')) return 'fiance';
  if (lower.includes('fiancées') || lower.includes('fiancees')) return 'fiancee';
  if (lower.includes('wives')) return 'wife';
  if (lower.includes('husbands')) return 'husband';

  if (
    lower.includes('family') ||
    lower.includes('parents') ||
    lower.includes('children') ||
    lower.includes('relatives')
  ) {
    return 'family';
  }

  if (
    lower.includes('coworker') ||
    lower.includes('colleague') ||
    lower.includes('boss') ||
    lower.includes('employee') ||
    lower.includes('work')
  ) {
    return 'coworkers';
  }

  if (
    lower.includes('boyfriend') ||
    lower.includes('girlfriend') ||
    lower.includes('fiance') ||
    lower.includes('fiancé') ||
    lower.includes('fiancee') ||
    lower.includes('fiancée') ||
    lower.includes('wife') ||
    lower.includes('husband') ||
    lower.includes('romantic') ||
    lower.includes('partner')
  ) {
    return 'romantic';
  }

  if (lower.includes('people in my life') || lower.includes('my life')) {
    return 'all';
  }

  return null;
}

export function getRelationshipsByGroup(group, sourceRelationships = []) {
  if (!Array.isArray(sourceRelationships) || !sourceRelationships.length) return [];

  if (group === 'all') {
    return sourceRelationships.filter((person) => person?.first_name && person?.relationship);
  }

  if (group === 'family') {
    const aliases = RELATIONSHIP_GROUP_ALIASES.family || [];
    return sourceRelationships.filter((person) => {
      const role = normalizeRelationshipRole(person?.relationship);
      return aliases.includes(role);
    });
  }

  if (group === 'coworkers') {
    const aliases = RELATIONSHIP_GROUP_ALIASES.coworkers || [];
    return sourceRelationships.filter((person) => {
      const role = normalizeRelationshipRole(person?.relationship);
      return aliases.includes(role);
    });
  }

  if (group === 'romantic') {
    const aliases = RELATIONSHIP_GROUP_ALIASES.romantic || [];
    return sourceRelationships.filter((person) => {
      const role = normalizeRelationshipRole(person?.relationship);
      return aliases.includes(role);
    });
  }

  return sourceRelationships.filter((person) => {
    const role = normalizeRelationshipRole(person?.relationship);
    return role === normalizeRelationshipRole(group);
  });
}

export function buildLastReferencedEntity({ name, role, type = 'person', entityId = null }) {
  if (!name) return null;

  return {
    entityId: entityId || null,
    type,
    name,
    role: role || null,
  };
}

export function formatNaturalNameList(items = []) {
  const names = items.map((item) => item?.first_name).filter(Boolean);

  if (!names.length) return '';
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;

  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
}
